import { inject, Injectable } from '@angular/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { PlatformService } from '@services/platform.service';

@Injectable({
  providedIn: 'root'
})
export class HapticsService {
  private readonly platformService = inject(PlatformService);

  public async impact(style: ImpactStyle): Promise<void> {
    await this.run((): Promise<void> => Haptics.impact({style}));
  }

  public async notification(type: NotificationType): Promise<void> {
    await this.run((): Promise<void> => Haptics.notification({type}));
  }

  public async vibrate(duration: number): Promise<void> {
    await this.run((): Promise<void> => Haptics.vibrate({duration}));
  }

  private async run(execute: () => Promise<void>): Promise<void> {
    if (!this.isAvailable()) return;

    try {
      await execute();
    } catch (error) {
      console.warn('Haptics error', error);
    }
  }

  private isAvailable(): boolean {
    if (this.platformService.isSSR) return false;
    if (this.platformService.isNativePlatform) return true;

    return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
  }
}
